import React from 'react';
import { Pagination as MuiPagination, Stack } from '@mui/material';

const Pagination = ({ count, page, onPageChange }) => {
    return (
        <Stack spacing={2} alignItems="center" style={{ marginTop: '20px' }}>
            <MuiPagination
                count={count}                page={page}
                onChange={(event, value) => onPageChange(value)}
                sx={{
                    '& .MuiPaginationItem-root': { color: 'other.main' },
                    '& .Mui-selected': {
                        backgroundColor: 'secondary.main',
                        color: 'other.main'
                    }
                }}

            />
        </Stack>
    );
};

export default Pagination;
